import { Pencil, Plus } from "lucide-react";

export const TrailerBar = ({ trailers, activeId, onSelect, onEdit, onNew, t }) => (
  <div className="load-bar" data-testid="trailer-bar">
    <select className="text-input load-select" value={activeId || ""} onChange={(e) => onSelect(e.target.value)} data-testid="trailer-select">
      {trailers.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
    </select>
    <button type="button" className="ghost-btn" onClick={onEdit} aria-label={t("Edit trailer pockets")} data-testid="edit-trailer-btn"><Pencil size={16} /></button>
    <button type="button" className="ghost-btn" onClick={onNew} aria-label={t("New trailer")} data-testid="new-trailer-btn"><Plus size={16} /></button>
  </div>
);

export const CustomerBar = ({ customers, customerId, onSelect, onEdit, onNew, t }) => (
  <div className="load-bar" data-testid="customer-bar">
    <select className="text-input load-select" value={customerId || ""} onChange={(e) => onSelect(e.target.value || null)} data-testid="customer-select">
      <option value="">{t("No customer — enter by product")}</option>
      {customers.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
    </select>
    {customerId && <button type="button" className="ghost-btn" onClick={onEdit} aria-label={t("Edit customer tanks")} data-testid="edit-customer-btn"><Pencil size={16} /></button>}
    <button type="button" className="ghost-btn" onClick={onNew} aria-label={t("New customer")} data-testid="new-customer-btn"><Plus size={16} /></button>
  </div>
);
